import {
  ReadOutlined,
  FileImageOutlined,
  QuestionCircleOutlined,
  PlaySquareOutlined,
  ScheduleOutlined,
  SafetyOutlined,
  InfoCircleOutlined,
  LockOutlined,
  RollbackOutlined,
  PictureOutlined,
  SettingOutlined,
  GlobalOutlined
} from '@ant-design/icons';

const cms = {
  id: 'group-cms',
  title: 'CMS',
  type: 'group',
  children: [
    // Content
    {
      id: 'cms-content',
      title: 'Marketing Management',
      type: 'collapse',
      icon: ReadOutlined,
      children: [
        {
          id: 'cms-banner',
          title: 'Banners',
          type: 'item',
          url: '/cms/banner',
          icon: PictureOutlined
        },
        {
          id: 'cms-story',
          title: 'Stories',
          type: 'item',
          url: '/cms/story',
          icon: PlaySquareOutlined
        },
        {
          id: 'cms-blog',
          title: 'Blog',
          type: 'item',
          url: '/cms/blog',
          icon: ScheduleOutlined
        }
      ]
    },

    // Website Pages
    {
      id: 'cms-pages',
      title: 'Content Management',
      type: 'collapse',
      icon: GlobalOutlined,
      children: [
        {
          id: 'cms-about',
          title: 'About Us',
          type: 'item',
          url: '/cms/about-us',
          icon: InfoCircleOutlined
        },
        {
          id: 'cms-terms',
          title: 'Terms & Condition',
          type: 'item',
          url: '/cms/termsAndCondition',
          icon: SafetyOutlined
        },
        {
          id: 'cms-privacy',
          title: 'Privacy Policy',
          type: 'item',
          url: '/cms/privacyPolicy',
          icon: LockOutlined
        },
        {
          id: 'cms-refund',
          title: 'Refund Policy',
          type: 'item',
          url: '/cms/refundPolicy',
          icon: RollbackOutlined
        }
      ]
    },

    // Support
    {
      id: 'cms-support',
      title: 'Support & Help',
      type: 'collapse',
      icon: QuestionCircleOutlined,
      children: [
        {
          id: 'cms-faq',
          title: 'FAQ',
          type: 'item',
          url: '/cms/faq',
          icon: QuestionCircleOutlined
        },
        {
          id: 'cms-user-report',
          title: 'User Reports',
          type: 'item',
          url: '/cms/user-report',
          icon: FileImageOutlined
        }
      ]
    }
  ]
};

export default cms;
